import { FunctionComponent, useEffect, useRef, useState } from 'react'

import { importDependency } from 'core-components/helpers'
import { getDependency, isDependencyLoaded } from 'core-components/helpers/importDepencency'

interface IUseImportDependency {
  key: string
  importFunction: () => any
  defaultValue?: FunctionComponent<any>
}

export const useImportDependency = ({
  key,
  importFunction,
  defaultValue,
}: IUseImportDependency) => {
  const moduleRef = useRef<FunctionComponent<any>>(
    isDependencyLoaded(key) ? getDependency(key) : defaultValue || (() => null)
  )
  const [isDependencyLoading, setLoading] = useState<boolean>(!isDependencyLoaded(key))

  useEffect(() => {
    if (!isDependencyLoaded(key)) {
      setLoading(true)
      importDependency(key, importFunction)
        .then((m) => {
          if (m) {
            moduleRef.current = m
          }
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }, [importFunction, key])

  return { isDependencyLoading, Module: moduleRef.current }
}
